export const gateway_uri = process.env.REACT_APP_APIGATEWAY_URI;
export const ambiente = process.env.REACT_APP_AMBIENTE;

export const user_name = process.env.REACT_APP_API_USR;
export const password = process.env.REACT_APP_API_PWD;
export const token = process.env.REACT_APP_TOKEN;
export const PENHOR_RURAL =
    process.env.REACT_APP_PENHOR || window.location.host.split('.')[0] === 'simulador-penhor-rural';
export const URL_PORTAL_PARCEIROS = process.env.REACT_APP_URL_PORTAL_PARCEIROS;
